// C:\Ava_Local\Ava_API\avaai_dashboard\frontend\src\pages\education\SubtractionPage.tsx
import React from "react";
import TutorPage from "./TutorPage";

export default function SubtractionPage() {
  return <TutorPage initialTopic="Subtraction" lockTopic />;
}